import { MediaDto, mediaFromDto, mediaToDto } from "@domain/media/dtos";
import { ApplicationDegree, ApplicationLevel, ProgramTraining } from "@domain/program/programDraft";
import { Application, ApplicationVote } from "./application";
import { ApplicationDraft } from "./applicationDraft";

export interface ApplicationDraftDto extends Omit<
	ApplicationDraft,
	| "idPassport"
	| "proofResidence"
	| "selfDeclarationFinancialNeed"
	| "videoId"
	| "resume"
	| "englishCertificat"
	| "diploma"
	| "transcriptRecord"
	| "workCertificate"
> {
	idPassport?: string;
	proofResidence?: string;
	selfDeclarationFinancialNeed?: string;
	videoId?: string;
	resume?: string;
	englishCertificat?: string;
	diploma?: string;
	transcriptRecord?: string;
	workCertificate?: string;
}

export interface ApplicationDto extends Omit<
	Application,
	| "idPassport"
	| "proofResidence"
	| "selfDeclarationFinancialNeed"
	| "videoId"
	| "resume"
	| "englishCertificat"
	| "diploma"
	| "transcriptRecord"
	| "workCertificate"
> {
	idPassport?: MediaDto;
	proofResidence?: MediaDto;
	selfDeclarationFinancialNeed?: MediaDto;
	videoId?: MediaDto;
	resume?: MediaDto;
	diploma?: MediaDto;
	transcriptRecord?: MediaDto;
	workCertificate?: MediaDto;
	englishCertificat?: MediaDto;
	level: ApplicationLevel;
	degree: ApplicationDegree;
}

// export interface ApplicationToList extends Omit<Application,"degree"|"">{
// 	degree:string;

// }

export interface ProgramTrainingDto extends Omit<ProgramTraining, "program"> {
	credits: number[];
	degreeId: string;
	level: string;
	name: string;
}

export interface ApplicationVoteDto extends Omit<ApplicationVote, "slug" | "key" | "date"> {
	[key: string]: {
		key: string;
		date: Date;
	};
}

export function applicationDraftToDto(draft: ApplicationDraft): ApplicationDraftDto {
	return {
		...draft,
		idPassport: draft.idPassport?.id,
		proofResidence: draft.proofResidence?.id,
		selfDeclarationFinancialNeed: draft.selfDeclarationFinancialNeed?.id,
		videoId: draft.videoId?.id,
		resume: draft.resume?.id,
		diploma: draft.diploma?.id,
		transcriptRecord: draft.transcriptRecord?.id,
		workCertificate: draft.workCertificate?.id,
		englishCertificat: draft.englishCertificat?.id,
	};
}

export function applicationToDto(dto: Application): ApplicationDto {
	return {
		...dto,
		idPassport: dto.idPassport && mediaToDto(dto.idPassport),
		proofResidence: dto.proofResidence && mediaToDto(dto.proofResidence),
		selfDeclarationFinancialNeed: dto.selfDeclarationFinancialNeed && mediaToDto(dto.selfDeclarationFinancialNeed),
		videoId: dto.videoId && mediaToDto(dto.videoId),
		resume: dto.resume && mediaToDto(dto.resume),
		diploma: dto.diploma && mediaToDto(dto.diploma),
		transcriptRecord: dto.transcriptRecord && mediaToDto(dto.transcriptRecord),
		workCertificate: dto.workCertificate && mediaToDto(dto.workCertificate),
		englishCertificat: dto.englishCertificat && mediaToDto(dto.englishCertificat),
	};
}

export function applicationFromDto(dto: ApplicationDto): Application {
	return {
		...dto,
		idPassport: dto.idPassport ? mediaFromDto(dto.idPassport) : undefined,
		proofResidence: dto.proofResidence ? mediaFromDto(dto.proofResidence) : undefined,
		selfDeclarationFinancialNeed: dto.selfDeclarationFinancialNeed
			? mediaFromDto(dto.selfDeclarationFinancialNeed)
			: undefined,
		videoId: dto.videoId ? mediaFromDto(dto.videoId) : undefined,
		resume: dto.resume ? mediaFromDto(dto.resume) : undefined,
		diploma: dto.diploma ? mediaFromDto(dto.diploma) : undefined,
		transcriptRecord: dto.transcriptRecord ? mediaFromDto(dto.transcriptRecord) : undefined,
		workCertificate: dto.workCertificate ? mediaFromDto(dto.workCertificate) : undefined,
		englishCertificat: dto.englishCertificat ? mediaFromDto(dto.englishCertificat) : undefined,
		levelId: dto.level && dto.level.id,
		degreeId: dto.degree && dto.degree.id,
		dateBirth: dto.dateBirth && new Date(dto.dateBirth),
		desiredStartDate: dto.desiredStartDate && new Date(dto.desiredStartDate),
		countryResidence: dto.countryResidence,
		credits: dto.degree && dto.degree.credits,
	};
}

export function applicationVoteFromDto(dto: ApplicationVote): ApplicationVoteDto {
	return {
		[dto.slug]: {
			key: dto.key,
			date: new Date(dto.date),
		},
	};
}
